import React from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { initialValues, searchSchema, type SearchFormValues } from '../../schemas';
import type { PhiNganHang, PhiNganHangInput } from '@/types/schemas';
import BankFeeForm from './BankFeeForm';
import { FormMode } from '@/types/form';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;

  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: PhiNganHang | null;
  onSubmit?: (data: PhiNganHangInput) => void;
}

function BankFeeDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit
}: FormDialogProps) {
  const handleSubmit = (data: SearchFormValues) => {
    if (onSubmit) {
      onSubmit(data);
    }
  };
  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={false}
        disableEscapeKeyDown={false}
        titleIcon={<AritoIcon icon={12} />}
      >
        <AritoFormV2<SearchFormValues>
          mode={mode}
          hasAritoActionBar={false}
          schema={searchSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as Partial<SearchFormValues>}
          className='w-[900px]'
          headerFields={<BankFeeForm mode={mode} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>

      {/* Confirm Dialog */}
    </>
  );
}

export default BankFeeDialog;
